import React from 'react';
import { useContactInfo } from '../hooks/useContentful';

const EmergencySection = () => {

  const { contactInfo, loading, error } = useContactInfo();

  if (loading) {
    return (
      <section className="py-12 md:py-20 bg-gradient-to-r from-purple-700 to-purple-800 text-white text-center relative">
        {/* Section Separator */}
        <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-white/30 to-transparent"></div>
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="h-8 md:h-10 bg-gradient-to-r from-purple-400 via-purple-500 to-purple-400 rounded-lg w-3/4 mx-auto mb-6 animate-shimmer-purple"></div>
          <div className="h-5 md:h-6 bg-gradient-to-r from-purple-300 via-purple-400 to-purple-300 rounded-lg w-full mb-10 animate-shimmer-purple" style={{ animationDelay: '0.2s' }}></div>
          <div className="h-14 bg-gradient-to-r from-white/80 to-white/60 rounded-full w-80 mx-auto animate-pulse"></div>
        </div>
      </section>
    );
  }

  if (error) {
    // Fallback to static content
  }

  return (
    <section className="py-16 md:py-24 bg-gradient-to-r from-purple-600 to-pink-600 text-white text-center relative overflow-hidden">
      {/* Section Separator */}
      <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-white/30 to-transparent"></div>
      
      {/* Decorative elements */}
      <div className="absolute top-10 right-10 w-64 h-64 bg-white/10 rounded-full blur-3xl animate-float"></div>
      <div className="absolute bottom-10 left-10 w-80 h-80 bg-white/5 rounded-full blur-3xl animate-float" style={{ animationDelay: '1s' }}></div>
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 animate-fadeInUp">
        <div className="inline-flex items-center gap-2 bg-white/20 text-white px-4 py-2 rounded-full text-sm font-semibold mb-6">
          <i className="fas fa-exclamation-triangle"></i>
          Emergencia 24/7
        </div>
        <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-extrabold mb-6 md:mb-8 leading-tight">
          {contactInfo.titleEmergency} <span className="text-yellow-300">{contactInfo.titleHighlightEmergency}</span>?
        </h2>
        <p className="text-lg md:text-xl lg:text-2xl leading-relaxed mb-8 md:mb-12 px-4 max-w-4xl mx-auto">
          {contactInfo?.subtitleHighlightEmergency}
        </p>
        <a
          href={`tel:${contactInfo?.emergencyPhone}`}
          className="inline-block bg-white text-purple-600 px-10 md:px-16 py-5 md:py-6 rounded-full font-bold text-lg md:text-2xl shadow-2xl hover:shadow-3xl hover:bg-gray-100 transform hover:scale-105 transition-all duration-300"
        >
          <i className="fas fa-phone-volume mr-3 md:mr-4"></i>
          <span className="hidden sm:inline">Llama a Emergencias: </span>
          <span className="sm:hidden">Emergencias: </span>
          {contactInfo?.emergencyPhone}
        </a>
      </div>
    </section>
  );
};

export default EmergencySection;